var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperbarCalendar(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    style: {
      padding: "5px 6px 8px"
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 3.164H1v24.514h28V3.164zM1 7.93h28M23.725.736V5.73",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.5H7V12h16.5v6H18v5.5zM18 18H7M12.5 23.5V12M18 23.5V12",
    stroke: "#1C1C1C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667.736V5.73",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
export default SvgSuperbarCalendar;